
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <div className='title'>Das bedeuten die Gefahrengebiete</div>
    <p>{`In der Karte sind drei verschiedene Gefahrenstufen eingezeichnet: Erheblich, mittel und gering.`}</p>
    <div className='swatchContainer'>
      <div className='swatch subst ava' />
      <div className='swatch subst water' />
    </div>
    <b>Erheblich bedeutet,</b>  dass Personen sowohl innerhalb als auch ausserhalb von Gebäuden gefährdet sind. Mit der plötzlichen Zerstörung von Gebäuden ist zu rechnen. In solchen Gebieten werden keine neuen Bauten mehr erlaubt. Sind ausgeschiedene Bauzonen noch unbebaut, werden sie umgezont. Bestehende Bauten werden in der Regel stehen gelassen. Das Risiko darf aber durch Erweiterungen oder Umnutzungen nicht erhöht werden. Nutzungsbeschränkungen sind möglich, insbesondere bei sensiblen Objekten wie Schulen, Spitäler oder Campingplätzen. (Farbe in den offiziellen Gefahrenkarten der Kantone: Rot)
    <br /><br />
    <div className='swatchContainer'>
      <div className='swatch mean ava' />
      <div className='swatch mean water' />
    </div>
    <b>Mittel bedeutet,</b> dass Personen innerhalb von Gebäuden kaum gefährdet sind. Ausserhalb jedoch schon. Mit Schäden an Gebäuden ist zu rechnen. Solche Gebiete werden möglichst nicht neu bebaut. Und wenn, dann nur mit Auflagen. Sensible Objekte wie Schulen, Spitäler oder Campingplätze dürfen nicht neu erstellt werden. Bei bestehenden Bauten dürfen Nutzungsbeschränkungen erlassen werden. (Farbe in den offiziellen Gefahrenkarten der Kantone: Blau)
    <br /><br />
    <div className='swatchContainer'>
      <div className='swatch slight ava' />
      <div className='swatch slight water' />
    </div>
    <b>Gering bedeutet,</b> dass Personen kaum gefährdet sind. Erhebliche Sachschäden können jedoch auftreten. Gesetzliche Auflagen gibt es nur für sensible Objekte wie Schulen, Spitäler oder Campingplätze. Sie sollten in solchen Gebieten nur mit grosser Zurückhaltung gebaut werden (Farbe in den offiziellen Gefahrenkarten der Kantone: Gelb).
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;